(() => {
  const accountBalanceTables = document.querySelectorAll('.account-summary-table .tab-content > .col-lg-6:nth-child(2)');
  if (!accountBalanceTables.length) return;

  accountBalanceTables.forEach((table) => {
    const emptyRows = table.querySelectorAll('.table-account-overview-empty-row');

    const recentTitle = document.createElement('tr');
    recentTitle.classList.add('section-title', 'table-account-overview-border', 'table-account-overview-underline-grey');
    recentTitle.innerHTML = '<td colspan="2">Recent Orders</td>';
    table.querySelector('tbody').insertAdjacentElement('afterbegin', recentTitle);

    const salesTitle = document.createElement('tr');
    salesTitle.classList.add('section-title', 'table-account-overview-border', 'table-account-overview-underline-grey');
    salesTitle.innerHTML = '<td colspan="2">Recent Sales</td>';
    emptyRows[0].insertAdjacentElement('afterend', salesTitle);

    const outstandingTitle = document.createElement('tr');
    outstandingTitle.classList.add('section-title', 'table-account-overview-border', 'table-account-overview-underline-grey');
    outstandingTitle.innerHTML = '<td colspan="2">Outstanding Orders</td>';
    emptyRows[1].insertAdjacentElement('afterend', outstandingTitle);
  });
})();

(() => {
  const accountBalances = document.querySelectorAll('.account-balances');
  if (!accountBalances.length) return;

  accountBalances.forEach((balanceTable) => {
    const rows = balanceTable.querySelectorAll('tr');
    rows.forEach((row) => {
      const cells = Array.from(row.querySelectorAll('td'));
      cells.forEach((cell) => {
        if (cell.textContent.trim() === '- Credits') {
          row.classList.add('text-green');
        } else if (cell.textContent.trim() === '+ Finance Charges') {
          row.classList.add('text-red');
        }
      });
    });
  });
})();
